import Event from './event';

export default {
  profileView: function ({ currentUser, user, fromPath }) {
    return Event.track('profile:view', {
      current_user_id: currentUser && currentUser.id,
      profile_user_id: user && user.id,
      from_path: fromPath,
      self_select: currentUser && user && currentUser.id === user.id,
    });
  },

  profileSearchView: function ({ currentUser, user, searchTerm, recCount, groupCount }) {
    return Event.track('profile_search:view', {
      current_user_id: currentUser && currentUser.id,
      profile_user_id: user && user.id,
      search_term: searchTerm,
      rec_count: recCount,
      group_count: groupCount,
      hooks: ['profile-search-viewed'],
    });
  },

  profileUpdate: function ({ user }) {
    return Event.track('profile:update', {
      user_id: user.id,
    });
  },

  profileGroupsViewed: function ({ currentUser, groupIds, profileUserId }) {
    Event.track('profile:groups_viewed', {
      user_id: currentUser && currentUser.id,
      group_ids: groupIds,
      profile_user_id: profileUserId,
    });
  },

  profileShareCollection: function ({ currentUser, profileUserId, collectionId }) {
    Event.track('profile:share_collection', {
      user_id: currentUser && currentUser.id,
      profile_user_id: profileUserId,
      collection_id: collectionId,
    });
  },

  profileShareClicked: function ({ currentUser, profileUserId }) {
    Event.track('profile:share_click', {
      user_id: currentUser && currentUser.id,
      profile_user_id: profileUserId,
    });
  },

  groupView: function ({ group, user, fromPath, selfSelect }) {
    return Event.track('group:view', {
      group_base_id: group && group.id,
      user_id: user && user.id,
      email: user && user.email,
      from_path: fromPath,
      self_select: selfSelect,
      hooks: ['group-viewed'],
    });
  },

  groupDescriptionLinkClicked: function ({ user, group, url }) {
    return Event.track('group:description_link_click', {
      user_id: user && user.id,
      group_base_id: group && group.id,
      url: url,
    });
  },

  groupCoverPhotoChange: function ({ user, group }) {
    return Event.track('group:cover_photo_change', {
      user_id: user && user.id,
      group_base_id: group && group.id,
    });
  },

  groupRecsViewed: function ({ currentUser, recObjectIds, groupId }) {
    Event.track('group:recs_viewed', {
      user_id: currentUser && currentUser.id,
      rec_object_ids: recObjectIds,
      group_base_id: groupId,
    });
  },

  userNameClicked: function ({ user, group, rec, recObject, currentUser }) {
    return Event.track('user:name_clicked', {
      user_id: user && user.id,
      group_base_id: group && group.id,
      rec_id: rec && rec.id,
      rec_object_id: recObject && recObject.id,
      viewed_by_id: currentUser && currentUser.id,
    });
  },

  inviteCopyLink: function ({ currentUser, group }) {
    return Event.track('invite:copy_link', {
      user_id: currentUser.id,
      group_base_id: group.id,
    });
  },

  groupCopyLink: function ({ currentUser, group, relatedUserId }) {
    return Event.track('group:copy_link', {
      user_id: currentUser.id,
      group_base_id: group.id,
      related_user_id: relatedUserId,
    });
  },

  recLinkClicked: function ({ user, group, rec, url }) {
    let rec_user = rec && rec.user;

    return Event.track('rec:link_click', {
      user_id: user && user.id,
      group_base_id: group && group.id,
      rec_id: rec && rec.id,
      url: url,
      self_select: rec_user && user && rec_user.id == user.id,
    });
  },

  recExpanded: function ({ user, group, rec, recObject }) {
    return Event.track('rec:expand', {
      user_id: user && user.id,
      group_base_id: group && group.id,
      rec_id: rec && rec.id,
      rec_object_id: recObject && recObject.id,
    });
  },

  recNameClicked: function ({ user, group, rec }) {
    return Event.track('user:name_clicked', {
      user_id: rec && rec.user && rec.user.id,
      group_base_id: group && group.id,
      rec_id: rec && rec.id,
      viewed_by_id: user && user.id,
    });
  },

  photoClicked: function ({ user, group, recObject, photo }) {
    return Event.track('photo:clicked', {
      user_id: user && user.id,
      group_base_id: group && group.id,
      rec_object_id: recObject && recObject.id,
      photo_id: photo && photo.id,
    });
  },

  photoChanged: function ({ user, group, recObject, photo }) {
    return Event.track('photo:changed', {
      user_id: user && user.id,
      group_base_id: group && group.id,
      rec_object_id: recObject && recObject.id,
      photo_id: photo && photo.id,
    });
  },

  mapToggle: function ({ user, group, enabled, page }) {
    return Event.track('map:toggle', {
      user_id: user && user.id,
      group_base_id: group && group.id,
      page: page,
      enabled: enabled,
    });
  },

  contactViewed: function ({ user, group, recObject }) {
    return Event.track('contact:view', {
      user_id: user && user.id,
      group_base_id: group && group.id,
      rec_object_id: recObject && recObject.id,
    });
  },

  websiteClicked: function ({ user, group, recObject }) {
    return Event.track('website:click', {
      user_id: user && user.id,
      group_base_id: group && group.id,
      rec_object_id: recObject && recObject.id,
    });
  },

  instagramClicked: function ({ user, group, recObject }) {
    return Event.track('instagram:click', {
      user_id: user && user.id,
      group_base_id: group && group.id,
      rec_object_id: recObject && recObject.id,
    });
  },

  ratingClicked: function ({ user, recObject, recRating, group }) {
    return Event.track('rating:click', {
      user_id: user && user.id,
      group_base_id: group && group.id,
      rec_object_id: recObject && recObject.id,
      rec_rating_id: recRating && recRating.id,
    });
  },

  commentLikeAccountCreated: function ({ user, group, recObject, comment }) {
    return Event.track('comment_like:account_created', {
      user_id: user && user.id,
      group_base_id: group && group.id,
      rec_object_id: recObject && recObject.id,
      comment_id: comment.id,
    });
  },

  commentAccountCreated: function ({ user, group, recObject }) {
    return Event.track('comment:account_created', {
      user_id: user && user.id,
      group_base_id: group && group.id,
      rec_object_id: recObject && recObject.id,
    });
  },

  likeAccountCreated: function ({ user, group, recObject }) {
    return Event.track('like:account_created', {
      user_id: user && user.id,
      group_base_id: group && group.id,
      rec_object_id: recObject && recObject.id,
    });
  },

  commentLinkClicked: function ({ user, group, comment, url }) {
    Event.track('comment:link_click', {
      user_id: user && user.id,
      group_base_id: group && group.id,
      comment_id: comment && comment.id,
      url: url,
    });
  },

  detailViewSeen: function ({ user, group, recObject }) {
    Event.track('detailview:view', {
      user_id: user && user.id,
      group_base_id: group && group.id,
      rec_object_id: recObject && recObject.id,
    });
  },

  detailviewWeblinkClicked: function ({ user, group, recObject }) {
    Event.track('detailview:website_click', {
      user_id: user && user.id,
      group_base_id: group && group.id,
      rec_object_id: recObject && recObject.id,
    });
  },

  detailviewEmailClicked: function ({ user, group, recObject }) {
    Event.track('detailview:email_click', {
      user_id: user && user.id,
      group_base_id: group && group.id,
      rec_object_id: recObject && recObject.id,
    });
  },

  detailviewInstagramClicked: function ({ user, group, recObject }) {
    Event.track('detailview:instagram_click', {
      user_id: user && user.id,
      group_base_id: group && group.id,
      rec_object_id: recObject && recObject.id,
    });
  },

  detailviewPhoneClick: function ({ user, group, recObject }) {
    Event.track('detailview:phone_click', {
      user_id: user && user.id,
      group_base_id: group && group.id,
      rec_object_id: recObject && recObject.id,
    });
  },

  detailviewShareClicked: function ({ user, group, recObject }) {
    Event.track('detailview:share_click', {
      user_id: user && user.id,
      group_base_id: group && group.id,
      rec_object_id: recObject && recObject.id,
    });
  },

  autofillViewed: function ({ user, group, name }) {
    Event.track('autofill:view', {
      user_id: user && user.id,
      group_base_id: group && group.id,
      term: name,
    });
  },

  autofillRefreshed: function ({ user, group, name }) {
    Event.track('autofill:refresh', {
      user_id: user && user.id,
      group_base_id: group && group.id,
      term: name,
    });
  },

  autofillOptionEnabled: function ({ user, group, field }) {
    Event.track('autofill:option_enabled', {
      user_id: user && user.id,
      group_base_id: group && group.id,
      field: field,
    });
  },

  autofillEdited: function ({ user, group, field, value }) {
    Event.track('autofill:edit', {
      user_id: user && user.id,
      group_base_id: group && group.id,
      field: field,
      value: value,
    });
  },

  autofillClearCard: function ({ user, group }) {
    Event.track('autofill:clear_card', {
      user_id: user && user.id,
      group_base_id: group && group.id,
    });
  },

  viewInvitesClicked: function ({ user }) {
    Event.track('app_invite:view_invites_clicked', {
      user_id: user && user.id,
    });
  },

  appInviteCopyClicked: function ({ user, app_invite, page, type }) {
    Event.track('app_invite:copy', {
      user_id: user && user.id,
      app_invite_id: app_invite && app_invite.id,
      code: app_invite && app_invite.code,
      page: page,
      invite_text_type: type,
    });
  },

  appInviteInstaShare: function ({ user, app_invite }) {
    Event.track('app_invite:ig_dm_share', {
      user_id: user && user.id,
      app_invite_id: app_invite && app_invite.id,
      code: app_invite && app_invite.code,
    });
  },

  switchAccountsMenuItemClicked: function ({ currentUser }) {
    Event.track('user:switch_accounts_clicked', {
      user_id: currentUser?.id,
    });
  },

  cashbackEnabledClicked: function ({ user }) {
    Event.track('cashback:enabled_clicked', {
      user_id: user && user.id,
    });
  },

  notificationsViewed: function ({ user, notificationIds }) {
    Event.track('notification:viewed', {
      user_id: user && user.id,
      notification_ids: notificationIds,
    });
  },

  notificationsItemClick: function ({ user, notification, recObject, group, itemType }) {
    Event.track('notification:item_click', {
      user_id: user && user.id,
      notification_id: notification && notification.id,
      rec_object_id: recObject && recObject.id,
      group_base_id: group && group.id,
      item_type: itemType,
    });
  },

  notificationMenuOpen: function ({ user }) {
    Event.track('notification_menu:open', {
      user_id: user && user.id,
    });
  },

  notificationMenuClick: function ({ user, notification }) {
    Event.track('notification_menu:click', {
      user_id: user && user.id,
      notification_id: notification && notification.id,
    });
  },

  notificationMenuActionClick: function ({ user, notification }) {
    Event.track('notification_menu:action_click', {
      user_id: user && user.id,
      notification_id: notification && notification.id,
    });
  },

  discoverView: function ({ currentUser }) {
    Event.track('discover:view', {
      user_id: currentUser && currentUser.id,
    });
  },

  discoverCategoryClick: function ({ currentUser, category }) {
    Event.track('discover:category_click', {
      user_id: currentUser && currentUser.id,
      category_id: category && category.id,
      position: category && category.postion,
    });
  },

  discoverPageEndReached: function ({ currentUser, categoryId }) {
    Event.track('discover:page_end_reached', {
      user_id: currentUser && currentUser.id,
      category_id: categoryId,
    });
  },

  profilePageEndReached: function ({ currentUser, user }) {
    Event.track('profile:page_end_reached', {
      user_id: currentUser && currentUser.id,
      related_user_id: user && user.id,
    });
  },

  groupPageEndReached: function ({ currentUser, group }) {
    Event.track('group:page_end_reached', {
      user_id: currentUser && currentUser.id,
      group_base_id: group && group.id,
    });
  },

  discoverGroupsViewed: function ({ currentUser, groupIds }) {
    Event.track('discover:groups_viewed', {
      user_id: currentUser && currentUser.id,
      group_ids: groupIds,
      hooks: ['discover-groups-viewed'],
    });
  },

  userFollowed: function ({ currentUser, user, context, page }) {
    Event.track('user:followed', {
      user_id: currentUser && currentUser.id,
      followed_id: user && user.id,
      context: context,
      page: page,
    });
  },

  userUnfollowed: function ({ currentUser, user, context, page }) {
    Event.track('user:unfollowed', {
      user_id: currentUser && currentUser.id,
      unfollowed_id: user && user.id,
      context: context,
      page: page,
    });
  },

  dashboardView: function ({ currentUser, currentTab }) {
    Event.track('dashboard:view', {
      user_id: currentUser && currentUser.id,
      tab: currentTab,
    });
  },

  suggestionCycled: function ({ currentUser }) {
    Event.track('suggestion:cycled', {
      user_id: currentUser && currentUser.id,
    });
  },

  pageView: function ({ user, from_path, to_path }) {
    Event.track('page:viewed', {
      user_id: user && user.id,
      from_path: from_path,
      to_path: to_path,
    });
  },

  listOptimizedClicked: function ({ currentUser, group }) {
    Event.track('list_optimized:clicked', {
      user_id: currentUser && currentUser.id,
      group_base_id: group.id,
    });
  },

  listOptimizedButtonClicked: function ({ currentUser, group }) {
    Event.track('list_optimized:modal_button_clicked', {
      user_id: currentUser && currentUser.id,
      group_base_id: group.id,
    });
  },

  globalSearchSelected: function ({ currentUser, term, group, recObject, user }) {
    Event.track('global_search:selected', {
      user_id: currentUser && currentUser.id,
      term: term,
      group_base_id: group && group.id,
      rec_object_id: recObject && recObject.id,
      related_user_id: user && user.id,
    });
  },

  globalSearchSearched: function ({ currentUser, term }) {
    Event.track('global_search:searched', {
      user_id: currentUser && currentUser.id,
      term: term,
    });
  },

  globalSearchTabClick: function ({ currentUser, tab, keyword }) {
    Event.track('global_search:tab_click', {
      user_id: currentUser && currentUser.id,
      tab: tab,
      keyword: keyword,
    });
  },

  socialViewOpen: function ({ currentUser, user, token }) {
    Event.track('social_view:open', {
      user_id: currentUser && currentUser.id,
      related_user_id: user && user.id,
      token: token,
    });
  },

  socialViewPlay: function ({ currentUser, user, slide, slideNumber, token }) {
    Event.track('social_view:play', {
      user_id: currentUser && currentUser.id,
      related_user_id: user && user.id,
      slide: slide,
      slide_number: slideNumber,
      token: token,
    });
  },

  socialViewShare: function ({ currentUser, user, token }) {
    Event.track('social_view:share', {
      user_id: currentUser && currentUser.id,
      related_user_id: user && user.id,
      token: token,
    });
  },

  socialViewShareSlide: function ({ currentUser, user, slide, slideNumber, token }) {
    Event.track('social_view:share_slide', {
      user_id: currentUser && currentUser.id,
      related_user_id: user && user.id,
      slide: slide,
      slide_number: slideNumber,
      token: token,
    });
  },

  socialViewSlidePaused: function ({ currentUser, user, slide, slideNumber, token }) {
    Event.track('social_view:slide_paused', {
      user_id: currentUser && currentUser.id,
      related_user_id: user && user.id,
      slide: slide,
      slide_number: slideNumber,
      token: token,
    });
  },

  tuneUpView: function ({ currentUser, from, cards }) {
    Event.track('tune_up:view', {
      user_id: currentUser && currentUser.id,
      from: from,
      cards: cards,
    });
  },

  tuneUpClickStartFixing: function ({ currentUser }) {
    Event.track('tune_up:click_start_fixing', {
      user_id: currentUser && currentUser.id,
    });
  },

  tuneUpCardViewed: function ({ currentUser, cardType, numberAvailable, numberCompleted, numberSnoozed, relevantIds }) {
    Event.track('tune_up:card_viewed', {
      user_id: currentUser && currentUser.id,
      card_type: cardType,
      number_available: numberAvailable,
      number_completed: numberCompleted,
      number_snoozed: numberSnoozed,
      relevant_ids: relevantIds,
    });
  },

  tuneUpSkipAction: function ({ currentUser, cardType, buttonText }) {
    Event.track('tune_up:skip_action', {
      user_id: currentUser && currentUser.id,
      card_type: cardType,
      button_text: buttonText,
    });
  },

  tuneUpAcceptAction: function ({ currentUser, cardType, buttonText }) {
    Event.track('tune_up:accept_action', {
      user_id: currentUser && currentUser.id,
      card_type: cardType,
      button_text: buttonText,
    });
  },

  tuneUpSocialUpdate: function ({ currentUser, cardType, social }) {
    Event.track('tune_up:accept_action', {
      user_id: currentUser && currentUser.id,
      card_type: cardType,
      social_platform: social.link_type,
      social_username_entered: social.username,
    });
  },

  tuneUpSocialDelete: function ({ currentUser, social }) {
    Event.track('tune_up:social_link_deleted', {
      user_id: currentUser && currentUser.id,
      link: social.url,
    });
  },

  tuneUpCloseModal: function ({ currentUser, cardType }) {
    Event.track('tune_up:close_modal', {
      user_id: currentUser && currentUser.id,
      card_type: cardType,
    });
  },

  generatedListStartFromListIdeas: function ({ currentUser }) {
    Event.track('generated_list:start_from_list_ideas', {
      user_id: currentUser && currentUser.id,
    });
  },

  generatedListSelectListIdea: function ({ currentUser, listIdea }) {
    Event.track('generated_list:select_list_idea', {
      user_id: currentUser && currentUser.id,
      list_idea: listIdea,
    });
  },

  generatedRecSubmitAnswer: function ({ currentUser, group, listIdea, listIdeaAnswer }) {
    Event.track('generated_rec:submit_answer', {
      user_id: currentUser && currentUser.id,
      group_base_id: group && group.id,
      list_idea: listIdea,
      list_idea_answer: listIdeaAnswer,
    });
  },

  feedViewed: function ({ currentUser }) {
    Event.track('feed:viewed', {
      user_id: currentUser && currentUser.id,
    });
  },

  feedCardViewed: function ({ currentUser, card }) {
    Event.track('feed:card_viewed', {
      user_id: currentUser && currentUser.id,
      card_id: card.id,
      card_type: card.card_type,
    });
  },

  feedLinkClicked: function ({ currentUser, card, url }) {
    Event.track('feed:link_clicked', {
      user_id: currentUser && currentUser.id,
      card_id: card.id,
      card_type: card.card_type,
      url: url,
    });
  },
  profileSocialLinkClicked: function ({ currentUser, user, path, linkDomain, link }) {
    return Event.track('profile:social_link_click', {
      user_id: currentUser && currentUser.id,
      related_user_id: user && user.id,
      path: path,
      link_domain: linkDomain,
      link: link,
    });
  },

  spotlightViewProfileClicked: function ({ currentUser, user, path }) {
    return Event.track('spotlight:view_profile', {
      user_id: currentUser && currentUser.id,
      related_user_id: user && user.id,
      path: path,
    });
  },
  spotlightSocialLinkClicked: function ({ currentUser, user, path, linkDomain, link }) {
    return Event.track('spotlight:social_link_click', {
      user_id: currentUser && currentUser.id,
      related_user_id: user && user.id,
      path: path,
      link_domain: linkDomain,
      link: link,
    });
  },
  spotlightViewed: function ({ currentUser, user, path, buttonType }) {
    return Event.track('spotlight:view', {
      user_id: currentUser && currentUser.id,
      related_user_id: user && user.id,
      path: path,
      button_type: buttonType,
    });
  },
  spotlightNextImage: function ({ currentUser, user, path }) {
    return Event.track('spotlight:next_image', {
      user_id: currentUser && currentUser.id,
      related_user_id: user && user.id,
      path: path,
    });
  },

  spotlightListNextImage: function ({ currentUser, user, path, groupBase }) {
    return Event.track('spotlight:list_next_image', {
      user_id: currentUser && currentUser.id,
      related_user_id: user && user.id,
      group_base_id: groupBase && groupBase.id,
      path: path,
    });
  },

  spotlightListClicked: function ({ currentUser, user, path, groupBase }) {
    return Event.track('spotlight:list_click', {
      user_id: currentUser && currentUser.id,
      related_user_id: user && user.id,
      group_base_id: groupBase && groupBase.id,
      path: path,
    });
  },

  spotlightListLiked: function ({ currentUser, user, path, groupBase }) {
    return Event.track('spotlight:list_like', {
      user_id: currentUser && currentUser.id,
      related_user_id: user && user.id,
      group_base_id: groupBase && groupBase.id,
      path: path,
    });
  },

  spotlightListCommentClicked: function ({ currentUser, user, path, groupBase }) {
    return Event.track('spotlight:list_comment_clicked', {
      user_id: currentUser && currentUser.id,
      related_user_id: user && user.id,
      group_base_id: groupBase && groupBase.id,
      path: path,
    });
  },

  spotlightListBookmarked: function ({ currentUser, user, path, groupBase }) {
    return Event.track('spotlight:list_bookmark', {
      user_id: currentUser && currentUser.id,
      related_user_id: user && user.id,
      group_base_id: groupBase && groupBase.id,
      path: path,
    });
  },

  spotlightFollowClicked: function ({ currentUser, user, path, action }) {
    return Event.track('spotlight:follow', {
      user_id: currentUser && currentUser.id,
      related_user_id: user && user.id,
      path: path,
      action: action,
    });
  },

  suggestedFollowViewed: function ({ currentUser, relatedUserId, page }) {
    return Event.track('suggested_follow:viewed', {
      user_id: currentUser && currentUser.id,
      related_user_id: relatedUserId,
      page: page,
    });
  },

  suggestedFollowFollowed: function ({ currentUser, relatedUserId, page }) {
    return Event.track('suggested_follow:followed', {
      user_id: currentUser && currentUser.id,
      related_user_id: relatedUserId,
      page: page,
    });
  },

  suggestedFollowClicked: function ({ currentUser, relatedUserId, page }) {
    return Event.track('suggested_follow:clicked', {
      user_id: currentUser && currentUser.id,
      related_user_id: relatedUserId,
      page: page,
    });
  },

  suggestedFollowDismissed: function ({ currentUser, relatedUserId, page }) {
    return Event.track('suggested_follow:dismissed', {
      user_id: currentUser && currentUser.id,
      related_user_id: relatedUserId,
      page: page,
    });
  },

  signupModalOpened: function (eventDetails) {
    return Event.track('signup_modal:opened', eventDetails);
  },

  waitlistMessageView: function ({ user, pendingUserEmail, pageUrl }) {
    Event.track('signup_modal:waitlist_message_view', {
      user_id: user && user.id,
      pending_user_email: pendingUserEmail,
      page_url: pageUrl,
    });
  },

  skipWaitlistClick: function ({ user, pendingUserEmail, pageUrl }) {
    Event.track('signup_modal:skip_waitlist_click', {
      user_id: user && user.id,
      pending_user_email: pendingUserEmail,
      page_url: pageUrl,
    });
  },

  invitesNudgeViewed: function ({ currentUser }) {
    return Event.track('invites_nudge:viewed', {
      user_id: currentUser && currentUser.id,
    });
  },

  invitesReviewClick: function ({ currentUser, nInviteesDisplayed }) {
    return Event.track('invites_nudge:review_click', {
      user_id: currentUser && currentUser.id,
      n_invitees_displayed: nInviteesDisplayed,
    });
  },

  invitesEditTemplate: function ({ currentUser }) {
    return Event.track('invites_nudge:edit_template', {
      user_id: currentUser && currentUser.id,
    });
  },

  suggestedInvitesView: function ({ currentUser, nSuggestions, alreadySkipped }) {
    return Event.track('suggested_invites:view', {
      user_id: currentUser && currentUser.id,
      n_suggestions: nSuggestions,
      already_skipped: alreadySkipped,
    });
  },

  suggestedInvitesSelectSearchbar: function ({ currentUser }) {
    return Event.track('suggested_invites:select_searchbar', {
      user_id: currentUser && currentUser.id,
    });
  },

  suggestedInvitesClick: function ({ currentUser, nSuggestions, alreadySkipped }) {
    return Event.track('suggested_invites:click', {
      user_id: currentUser && currentUser.id,
      n_suggestions: nSuggestions,
      already_skipped: alreadySkipped,
    });
  },

  suggestedInvitesSuggestionSkip: function ({ currentUser, suggestedInviteUsername }) {
    return Event.track('suggested_invites:suggestion_skip', {
      user_id: currentUser && currentUser.id,
      suggested_invite_username: suggestedInviteUsername,
    });
  },

  suggestedInvitesSendDmClick: function ({
    currentUser,
    suggestedInviteUsername,
    platform,
    resend,
    from_search_results,
  }) {
    return Event.track('suggested_invites:send_dm_click', {
      user_id: currentUser && currentUser.id,
      suggested_invite_username: suggestedInviteUsername,
      platform: platform,
      resend: resend,
      from_search_results: from_search_results,
    });
  },

  suggestedInvitesViewSkippedClick: function ({ currentUser, nSuggestions }) {
    return Event.track('suggested_invites:view_skipped_click', {
      user_id: currentUser && currentUser.id,
      n_suggestions: nSuggestions,
    });
  },

  suggestedInvitesLinkClick: function ({ currentUser, instagram_username, inviterUserId }) {
    return Event.track('suggested_invites:link_click', {
      user_id: currentUser && currentUser.id,
      instagram_username: instagram_username,
      inviter_user_id: inviterUserId,
    });
  },

  suggestedInvitesIncentiveButtonClick: function ({ currentUser, buttonText }) {
    return Event.track('suggested_invites:incentive_button_click', {
      user_id: currentUser && currentUser.id,
      button_text: buttonText,
    });
  },

  suggestedInvitesUserCreate: function ({ currentUser, instagramMutualFollowerId, instagramUsername, inviterUserId }) {
    return Event.track('suggested_invites:user_create', {
      user_id: currentUser && currentUser.id,
      instagram_mutual_follower_id: instagramMutualFollowerId,
      instagram_username: instagramUsername,
      inviter_user_id: inviterUserId,
    });
  },

  suggestedInvitesViewReward: function ({ currentUser, amountEarnedCents, nInvitedFriends }) {
    return Event.track('suggested_invites:view_reward', {
      user_id: currentUser && currentUser.id,
      amount_earned_cents: amountEarnedCents,
      n_invited_friends: nInvitedFriends,
    });
  },

  externalLinkClick: function ({ user, params }) {
    return Event.track('external:link_click', {
      user_id: user && user.id,
      params: JSON.stringify(params),
    });
  },
  getRecsAnswered: function ({ recQuizId, recQuizTitle, answer, note, instagram }) {
    return Event.track('rec_request:submit', {
      rec_quiz_id: recQuizId,
      question: recQuizTitle,
      answer: answer,
      note: note,
      instagram: instagram,
    });
  },
  getRecsOwnRequested: function ({ recQuizId, recQuizTitle, buttonText, instagram }) {
    return Event.track('rec_request:app_store_link_click', {
      rec_quiz_id: recQuizId,
      question: recQuizTitle,
      button_text: buttonText,
      instagram: instagram,
    });
  },

  // Onboarding events
  signInClick: function () {
    Event.track('onboarding:sign_in_click', {});
  },

  createAccountClick: function () {
    return Event.track('onboarding:create_account_click', {});
  },

  signedUpWithGoogle: function () {
    return Event.track('onboarding:signed_up_with_google', {});
  },

  signedUpWithEmail: function (data = {}) {
    return Event.track('onboarding:signed_up_with_email', data);
  },

  fullNameEntered: function ({ value }) {
    return Event.track('onboarding:full-name', { value });
  },

  emailEntered: function (data = {}) {
    return Event.track('onboarding:email_entered', data);
  },

  passwordEntered: function () {
    return Event.track('onboarding:password_entered', {});
  },

  skipWaitlist: function () {
    return Event.track('onboarding:skip_waitlist', {});
  },

  inviteCodeEntered: function () {
    return Event.track('onboarding:invite_code_entered', {});
  },

  usernameEntered: function () {
    return Event.track('onboarding:username_entered', {});
  },

  addProfilePhotoClick: function () {
    return Event.track('onboarding:add_profile_photo_click', {});
  },

  profilePhotoSkipClick: function () {
    return Event.track('onboarding:profile_photo_skip_click', {});
  },

  profilePhotoNextClick: function () {
    return Event.track('onboarding:profile_photo_next_click', {});
  },

  bioEntered: function ({ bio }) {
    return Event.track('onboarding:bio_entered', { bio });
  },

  bioSkipClick: function () {
    return Event.track('onboarding:bio_skip_click', {});
  },

  socialsEntered: function ({ ig, tiktok }) {
    return Event.track('onboarding:socials_entered', { ig, tiktok });
  },

  socialsSkip: function ({ ig, tiktok }) {
    return Event.track('onboarding:socials_skip', { ig, tiktok });
  },

  joiningScreenNext: function () {
    return Event.track('onboarding:joining_screen_next', {});
  },

  addFirstRecNext: function () {
    return Event.track('onboarding:add_first_rec_next', {});
  },

  categoryRefresh: (data) => {
    Event.track('onboarding:category_refresh', data);
  },
  autofillSearch: (data) => {
    Event.track('onboarding:autofill_search', data);
  },
  addMoreLaterClick: () => {
    Event.track('onboarding:add_more_later_click', {});
  },
  anotherRecClick: (data) => {
    Event.track('onboarding:another_rec_click', data);
  },
  addLocalRecNextClick: () => {
    Event.track('onboarding:add_local_rec_next_click', {});
  },
  optimizedNext: () => {
    Event.track('onboarding:optimized_next', {});
  },
  welcomeNext: () => {
    Event.track('onboarding:welcome_next', {});
  },
};
